import { DatadogEventProcessor } from ".";

const apiKeyRegex = /SG(\.[^.]+){2,}/g;
const ipRegex =
  /(\d{1,3}\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*)(?:\/\d{1,2})?(?:\[.*?\])?)/g;

export const IP_REDACTED = "IP_REDACTED";
export const API_KEY_REDACTED = "API_KEY_REDACTED";

interface Redactions {
  searchValue: RegExp;
  replaceValue: string;
}

/*
 * Add more redactions here and they'll run against all editable event fields.
 */
const redactions: Redactions[] = [
  {
    searchValue: apiKeyRegex,
    replaceValue: API_KEY_REDACTED,
  },
  {
    searchValue: ipRegex,
    replaceValue: IP_REDACTED,
  },
];

const redactData = (sourceString: string, searchValue: RegExp, replaceValue: string) => {
  if (!sourceString) {
    return sourceString;
  }
  return sourceString.replace(searchValue, replaceValue);
};

/** Redacts sensitive data from all editable fields of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
export const redactSensitiveData: DatadogEventProcessor = (event) => {
  redactions.forEach((redaction) => {
    const { searchValue, replaceValue } = redaction;
    event.view.url = redactData(event.view.url, searchValue, replaceValue);

    if (event.view.referrer) {
      event.view.referrer = redactData(event.view.referrer, searchValue, replaceValue);
    }

    if (event.type === "error") {
      const { error } = event;
      error.message = redactData(error.message, searchValue, replaceValue);
      if (error.stack) {
        error.stack = redactData(error.stack, searchValue, replaceValue);
      }
      if (error.resource) {
        error.resource.url = redactData(error.resource.url, searchValue, replaceValue);
      }
    }

    if (event.type === "resource") {
      event.resource.url = redactData(event.resource.url, searchValue, replaceValue);
    }

    if (event.type === "action") {
      if (event.action?.target?.name) {
        event.action.target.name = redactData(event.action.target.name, searchValue, replaceValue);
      }
    }
  });
};
